export default __webpack_public_path__ + "static/media/B650.69bfdd41.webp";